<template>
  <div class="uploader">
    <div class="uploader-main">
      <!-- 桌面端上传 -->
      <YorkbbsDesktopUploader
        :fileList.sync="_fileList"
        :uploadLimit="uploadLimit"
        @success="onDesktopUpload"
      ></YorkbbsDesktopUploader>

      <div class="uploader-or">或</div>

      <!-- 手机传图 -->
      <YorkbbsMobileUploader @change="onMobileChange" @success="onMobileUpload"></YorkbbsMobileUploader>
    </div>

    <!-- 上传提示 -->
    <slot></slot>

    <!-- 预览 -->
    <YorkbbsDraggable
      v-if="previewVisible && _fileList.length > 0"
      :value="_fileList"
      @input="onDragged"
      class="uploader-preview"
      :options="{ animation: 150 }"
    >
      <transition-group class="uploader-preview__list" tag="ul">
        <li class="uploader-preview__item" v-for="(item, i) in thumbFileList" :key="`${item}-${i}`">
          <img class="uploader-preview__image" :src="item" />
          <div class="uploader-preview__close">
            <i class="yk-close" @click="onRemove(i)"></i>
          </div>
        </li>
      </transition-group>
    </YorkbbsDraggable>
  </div>
</template>
<script>
import YorkbbsDesktopUploader from '@/common/uploader-desktop.vue';
import YorkbbsMobileUploader from '@/common/uploader-mobile.vue';
import YorkbbsDraggable from 'vuedraggable';
import { webpFormat } from '@/utils/utils';
export default {
  name: 'Uploader',
  components: { YorkbbsDesktopUploader, YorkbbsMobileUploader, YorkbbsDraggable },
  props: {
    // 文件列表
    fileList: {
      type: Array,
      default: () => [],
    },
    // 是否显示图片预览
    previewVisible: {
      type: Boolean,
      default: true,
    },
    // 上传文件最大数量
    uploadLimit: Number,
  },
  data() {
    return {};
  },
  computed: {
    _fileList: {
      get() {
        return this.fileList;
      },
      set(fileList) {
        this.$emit('update:fileList', fileList);
      },
    },
    thumbFileList() {
      return this.fileList.map(x => webpFormat(x, 150));
    },
  },
  methods: {
    /**
     * 图片拖拽
     */
    onDragged(fileList) {
      this._fileList = [...fileList];
    },
    /**
     * 删除图片
     */
    onRemove(index) {
      const fileList = [...this._fileList];
      fileList.splice(index, 1);
      this._fileList = fileList;
    },
    /**
     * 接收移动端传图
     */
    onMobileChange(fileList) {
      const _fileList = [...this._fileList, ...fileList];

      if (this.uploadLimit && _fileList.length > this.uploadLimit) {
        this.$warning(`最多上传${this.uploadLimit}张图片`);
      }

      this._fileList = _fileList.slice(0, this.uploadLimit);
    },
    /**
     * 桌面端上传成功
     */
    onDesktopUpload(fileList) {
      this.$emit('success', [...fileList]);
      this.$emit('desktopSuccess', [...fileList]);
    },
    /**
     * 移动端上传成功
     */
    onMobileUpload(fileList) {
      this.$emit('success', [...fileList]);
      this.$emit('mobileSuccess', [...fileList]);
    },
  },
};
</script>
<style lang="scss" scoped>
.uploader-main {
  display: flex;
}
.uploader-or {
  font-size: 14px;
  color: var(--text-color-3);
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 20px;
}
.uploader-preview {
  margin-top: 20px;
}
.uploader-preview__list {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;
  counter-reset: index;
}
.uploader-preview__item {
  margin: 0 15px 20px 15px;
  position: relative;
  counter-increment: index;
}
.uploader-preview__close {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #000;
  position: absolute;
  top: -12px;
  right: -12px;
  color: #fff;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.uploader-preview__image {
  width: 150px;
  max-height: 135px;
  object-fit: cover;
}
</style>
